import { getRole } from './getRole'

export type CargoDeleteContext = {
  reportAssignedUserId?: number | null
}

export function canCurrentUserDeleteCargo(
  cargo: {
    created_by?: number | null
    report?: { user?: { id?: number | null } }
  },
  ctx?: CargoDeleteContext
): boolean {
  const { isAdmin, isOwner, userId } = getRole()
  if (isAdmin || isOwner) return true
  if (userId == null) return false

  if (cargo.created_by != null) {
    return Number(cargo.created_by) === Number(userId)
  }

  const reportDriverId =
    ctx?.reportAssignedUserId ?? cargo.report?.user?.id ?? null
  if (reportDriverId != null && Number(reportDriverId) === Number(userId)) {
    return true
  }

  return false
}
